import React from 'react';
import _ from 'lodash';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Create';
import { __ } from './__';
import {toNumber} from "./toNumber";
import CouriersIcon from "@mui/icons-material/LocalShipping";
import {IMAGES} from "../config";

/**
 * Vratime buttony pre reklamaciu.
 *
 * @param {Object} item
 * @param {Object} options
 *
 * @return {Object}
 */
export const getComplaintButtons = (item, options = {}) => {
    options = { ...{
        hasPermissionEdit: false,
        hasPermissionDelete: false,
        hasPermissionSend: false,
        userCouriers: {},
        couriers: {},
        courierSettings: {},
        courierSettingsIds: [],
    }, ...options };

    // Caka zasielka na uhradu?
    let packagePayment = item.package.number === 'waiting_payment';

    // Caka zasielka na import
    let packageImport = item.package.number === 'waiting_import';

    // Bola zasielka odoslana?
    let packageSend = item.package.number !== '' && !packagePayment && !packageImport;

    // Ma zasielka error?
    let packageError = item.package.error !== '';

    // Je zasielka waiting?
    let packageWaiting = (_.has(item, 'waiting_package') && item.waiting_package)
        || (_.has(item.data, 'waiting_package') && item.data.waiting_package);

    // Kurier ktorym sa odosiela
    let sendCourier = item.package.courier !== '' ? item.package.courier : null;

    if (sendCourier === null) {
        // Vytiahneme konkretneho kuriera
        _.forEach(options.userCouriers, courier => {
            if (courier.settings.delivery_id.toString() === item._matchingData.Orders.data.delivery_type.id.toString()) {
                sendCourier = options.couriers[courier.courier_id];
            } else if (courier.settings.delivery_id.toString().indexOf('===') !== -1) {
                const delivery_ids = courier.settings.delivery_id.toString().split('===');

                _.forEach(delivery_ids, delivery_id => {
                    if (delivery_id.toString() === item._matchingData.Orders.data.delivery_type.id.toString()) {
                        sendCourier = options.couriers[courier.courier_id];
                    }
                })
            }
        });

        if (
            sendCourier === null
            && toNumber(options.courierSettings.default_courier) > 0
            && _.includes(options.courierSettingsIds, options.courierSettings.default_courier.toString())
            && item._matchingData.Orders.data.delivery_type.allow_default_courier
        ) {
            // Pozrieme na default kuriera
            _.forEach(options.user_couriers, courier => {
                if (courier.id.toString() === options.courierSettings.default_courier.toString()) {
                    sendCourier = options.couriers[courier.courier_id];
                }
            });
        }
    }

    let buttons = {
        edit: {
            name: __('Upraviť'),
            icon: <EditIcon />,
            callback: () => {},
            options: {},
        },
        send: {
            name: packageImport ? __('Zásielka čaká na spracovanie u prepravcu.') : (packagePayment ? __('Zásielka čaká na úhradu u prepravcu. Odkaz na platbu nájdete v zozname štítkov.') : (
                packageSend
                    ? (item.package.number === 'without_number'
                    ? __('Odoslané')
                    : __('Číslo zasielky: {NUMBER}. Kliknutím skopírujete do schránky.').replace('{NUMBER}', item.package.number))
                    : (
                        packageError
                            ? __('Chyba: {ERROR}. Kliknutím odošlete znovu.').replace('{ERROR}', item.package.error)
                            : (
                                packageWaiting
                                    ? __('Objednávka bude v najbližšom čase automatický odoslaná prepravcovi. Kliknutím odošlete manuálne.')
                                    : __('Odoslať prepravcovi')
                            )
                    )
            )),
            icon: <div className="courier-button"><CouriersIcon color={packageSend
                ? 'secondary'
                : (packageError
                        ? 'error'
                        : (packageWaiting || packagePayment || packageImport ? 'action' : 'inherit')
                )} />{sendCourier !== null ? <img
                src={IMAGES[`${sendCourier.toLowerCase()}-mini.png`]}
                className="courier-button__icon"
                alt={sendCourier}
            /> : null}</div>,
            callback: () => {},
            options: { packagePayment, packageImport, packageSend, packageError },
        },
        delete: {
            name: __('Zmazať'),
            icon: <DeleteIcon />,
            callback: () => {},
            options: {},
        },
    };

    if (!options.hasPermissionEdit) {
        // Nema pravo
        buttons = _.omit(buttons, ['edit']);
    }

    if (!options.hasPermissionSend) {
        // Nema pravo
        buttons = _.omit(buttons, ['send']);
    }

    if (!options.hasPermissionDelete) {
        // Nema pravo
        buttons = _.omit(buttons, ['delete']);
    }

    return buttons;
};
